/**
 * @author czy
 * 功能：辅助核算页面
 */

import { Service } from '@/tools'

export class AuxiliaryAccountingService<T extends TSettle.AuxiliaryAccounting> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.AuxiliaryAccounting}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询所有辅助核算
  ////api/settle/auxiliary/accounting/v1/pageList
  pageList = <K extends T['ApiPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageList', data)

  // 新增辅助核算 /api/settle/auxiliary/accounting/v1/save
  save = <K extends T['ApiSave']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSave', data)

  // 编辑辅助核算 /api/settle/auxiliary/accounting/v1/update
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  // 删除辅助核算/api/settle/auxiliary/accounting/v1/delete
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)
  //辅助核算不分页列表/api/settle/auxiliaryAccounting/v1/getList
  getList = <K extends T['ApiGetList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetList', data)
}
